import axios from 'axios'
import { directStoreDispatch } from '../index'
import { logout } from './actions/User.actions'
import { setAlert } from './actions/Alert.actions'

const axiosWrapper = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  responseType: 'json'
})

axiosWrapper.defaults.withCredentials = true

axiosWrapper.interceptors.response.use(undefined, function (error) {
  // A request that never got a reply has no status to read, and reading one
  // threw a TypeError in here — inside the very handler meant to report
  // failures, so a dropped request surfaced as nothing at all.
  if (!error.response) return Promise.reject(error)

  if (error.response.status === 401) {
    directStoreDispatch(
        setAlert(error.response.data?.message || 'Invalid authentication')
    )
    directStoreDispatch(logout())
  }

  if (error.response.status !== 401) {
    if (error.response.data?.message) {
      directStoreDispatch(setAlert(error.response.data.message))
    } else {
      directStoreDispatch(
          setAlert(`${error.response?.statusText || 'Something went wrong!'}`)
      )
    }
  }

  return Promise.reject(error)
})

export default axiosWrapper
